<script>
import numeral from 'numeral'
import { ResultCounter } from '@/components/page/result-counter'
import elementUiStyles from '@/assets/scss/modules/element-ui.module.scss'
import { toThaiDatetime } from '@/utils/datetime'

export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },

    pagination: {
      type: Object,
      default: () => ({})
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    getType(type) {
      switch (type) {
        case 'transfer':
          return 'โอนออก'

        case 'receive':
          return 'รับเข้า'

        case 'fill':
          return 'เติมทอง'
      }
    },

    getGoldType(type) {
      switch (type) {
        case 'sell':
          return 'ทองขาย'

        case 'old':
          return 'ทองเก่า'

        case 'fill':
          return 'เติมทอง'
      }
    },

    toDetailPage(id, type, goldType) {
      this.$emit('view', id, type, goldType)
    },

    handleCurrentChange(value) {
      this.$emit('pageChange', value)
    }
  },

  render() {
    const Tag = ({ props }) => {
      const getTag = () => {
        switch (props.type) {
          case 'accepted':
            return {
              label: 'รับแล้ว',
              color: '#d1d1d1'
            }

          case 'cancelled':
            return {
              label: 'ยกเลิก',
              color: '#d0021b',
              textColor: 'white'
            }

          default:
            return null
        }
      }

      const tag = getTag()

      return (
        tag && (
          <div
            style={{
              color: tag.textColor || 'black',
              backgroundColor: tag.color,
              fontSize: '0.625rem',
              fontWeight: 'bold',
              textAlign: 'center'
            }}
          >
            {tag.label}
          </div>
        )
      )
    }

    const DetailButton = ({ props }) => (
      <el-button
        size="medium"
        onClick={() => {
          this.toDetailPage(props.dataId, props.type, props.goldType)
        }}
      >
        See Detail <i class="el-icon-arrow-right"></i>
      </el-button>
    )

    return (
      <el-card
        {...{ directives: [{ name: 'loading', value: this.loading }] }}
        element-loading-background="rgba(0, 0, 0, 0.75)"
        element-loading-custom-class={elementUiStyles.loadingMask}
      >
        <ResultCounter
          value={this.pagination.total}
          style={{ marginBottom: '1rem' }}
        >
          ผลลัพธ์
        </ResultCounter>
        <el-table
          data={this.items}
          headerCellClassName={elementUiStyles.tableCell}
          cellClassName={elementUiStyles.tableCell}
          rowStyle={{ height: '4rem' }}
        >
          <el-table-column
            className={this.$style.verticalCell}
            width="23"
            scopedSlots={{
              default: ({ row }) => <Tag type={row.status} />
            }}
          />
          <el-table-column label="ID" prop="id" minWidth="150" />
          <el-table-column
            label="วันที่โอน"
            minWidth="150"
            scopedSlots={{ default: ({ row }) => toThaiDatetime(row.date) }}
          />
          <el-table-column
            label="ประเภท"
            minWidth="80"
            scopedSlots={{ default: ({ row }) => this.getType(row.type) }}
          />
          <el-table-column
            label="ต้นทาง/ปลายทาง"
            prop="target"
            minWidth="140"
          />
          <el-table-column
            label="ชนิดทอง"
            minWidth="80"
            scopedSlots={{
              default: ({ row }) => this.getGoldType(row.goldType)
            }}
          />
          <el-table-column
            label="น้ำหนัก (บาท)"
            align="right"
            minWidth="80"
            scopedSlots={{
              default: ({ row }) => numeral(row.weight).format('0,0.00')
            }}
          />
          <el-table-column
            label="น้ำหนัก (กรัม)"
            align="right"
            minWidth="100"
            scopedSlots={{
              default: ({ row }) => numeral(row.realWeight).format('0,0.00')
            }}
          />
          <el-table-column
            width="150"
            scopedSlots={{
              default: ({ row }) => (
                <DetailButton
                  dataId={row.id}
                  type={row.type}
                  goldType={row.goldType}
                />
              )
            }}
          />
        </el-table>
        <div
          style={{
            display: 'flex',
            marginTop: '1rem',
            overflow: 'auto hidden'
          }}
        >
          <el-pagination
            background
            currentPage={this.pagination.page}
            total={this.pagination.total}
            pageSize={this.pagination.pageSize}
            layout="prev, pager, next, jumper"
            style={{ margin: 'auto' }}
            on={{
              'current-change': this.handleCurrentChange
            }}
          />
        </div>
      </el-card>
    )
  }
}
</script>

<style lang="scss" module>
.verticalCell {
  overflow: hidden;

  :global(.cell) {
    padding: 0;
    width: 8rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-90deg);
  }
}
</style>
